import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseService } from 'src/app/services/base.service';
import { Subject, takeUntil } from 'rxjs';
import {
  CANCEL_INVOICE,
  CHECK_PAYMENT,
} from 'src/app/constants/endpoint.const';

@Component({
  standalone: false,
  selector: 'app-modal-qris',
  templateUrl: './modal-qris.component.html',
  styleUrls: ['./modal-qris.component.scss'],
})
export class ModalQrisComponent implements OnInit {
  destroy$ = new Subject();
  @Input() allowQris: boolean = true;
  @Input() invoiceId: string = '';
  @Input() expiredAt: string = '';
  @Input() qrCode: string = '';
  @Input() packageId: number = 0;
  @Input() totalPrice: number = 0;

  constructor(
    private route: Router,
    private activeModal: NgbActiveModal,
    private message: NzMessageService,
    private BaseService: BaseService
  ) {}

  ngOnInit(): void {}

  handlePaid(): void {
    const params = {
      invoice_id: this.invoiceId,
    };
    this.BaseService.getData(CHECK_PAYMENT, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res.data.status === 'paid') {
            this.activeModal.close();
            this.message.create(
              'success',
              'Your package has been successfully upgraded'
            );
            this.route.navigate(['subscriptions']);
          } else if (res.data.status === 'unpaid') {
            this.message.create(
              'error',
              'You still have an active bill, please complete the payment',
              {
                nzDuration: 5000,
              }
            );
          }
        },
        (err) => {
          this.message.create('error', err.data.errors);
        }
      );
  }

  cancelPayment() {
    const params = {
      invoice_id: this.invoiceId,
    };
    this.BaseService.putData(CANCEL_INVOICE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.activeModal.close();
          this.message.create('success', 'Your payment has been canceled');
        },
        (err) => {
          this.message.create('error', err.data.errors);
        }
      );
  }

  back() {
    this.route.navigate(['subscriptions/upgrade-package']);
  }
}
